module.exports = __webpack_public_path__ + "static/media/pheonix_70_years_logo.4386bfcf.png";